// Apple Sidebar Nav Item Styles — adapted for SFM dark-slate chrome
// ─────────────────────────────────────────────────────────────────────────────
//
// On the dark-slate (#1D2330) sidebar:
//   * Idle text uses brand.onChromeSubtle (white 65% alpha) for readable contrast
//   * Hover lifts to brand.onChrome (white 92%) + subtle white tint background
//   * Active item flips to brand.accent (amber #F88F1D) per F-003 Row 14 canon

import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';

export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 40,
  position: 'relative',
  textTransform: 'none',
  color: theme.palette.brand?.onChromeSubtle || 'rgba(255,255,255,0.65)',
  borderRadius: 10,
  marginBottom: 3,
  paddingLeft: 12,
  paddingRight: 12,
  fontSize: 15,
  fontWeight: 500,
  transition: 'background-color 0.15s ease, color 0.15s ease',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.06)',
    color: theme.palette.brand?.onChrome || '#FFFFFF',
  },
  '&.active': {
    color: theme.palette.brand?.accent || '#F88F1D',
    backgroundColor: 'rgba(248,143,29,0.12)',
    fontWeight: 600,
    boxShadow: `inset 0 0 0 1px rgba(248,143,29,0.32)`,
  },
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  width: 20,
  height: 20,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 'unset',
  marginRight: 10,
});
